import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import { Box, BoxBackLink } from 'components/common/box';
import { CourseInfo } from 'components/courses/course';

import type { GetUserCoursesCourseRes } from 'shared-types/responses';

interface Props {
  course: GetUserCoursesCourseRes['course'];
  courseCompletionLanguage: string | null;
  isUserPage?: boolean;
  languageVersion: string;
  loading: boolean;
}

const ProfileCourseInfo = ({
  course,
  courseCompletionLanguage,
  isUserPage,
  languageVersion,
  loading
}: Props) => {
  const {
    messages,
    pageState: { user }
  } = useReduxState();

  const profileBasePath = isUserPage ? `/users/${user?.id}` : '/profile';

  return (
    <div className="info">
      <Box
        loading={loading}
        title={
          <BoxBackLink
            as={`${profileBasePath}/courses`}
            href={`${profileBasePath}/courses`}
            text={messages.commonAllCourses}
          />
        }
      >
        {course ? (
          <div className="inner">
            <CourseInfo
              course={{
                ...course,
                isMandatoryInView: course.mandatoryReasons?.isMandatory
              }}
              courseCompletionLanguage={courseCompletionLanguage}
              displayPreviewLanguageVersion={languageVersion}
              enableCourseCompletionLanguageSelection={false}
              isProfilePage={true}
              titleLink={`/courses/${course.slug}`}
            />
          </div>
        ) : null}
      </Box>

      <style jsx>{`
        @media (min-width: ${breakpoints.medium}px) {
          .inner {
            padding: 5px;
          }
        }
      `}</style>
    </div>
  );
};

export default ProfileCourseInfo;
